import React from "react";
import "./footer.css";

const Footer = ({
  logo,
  home,
  about,
  experience,
  services,
  portfolio,
  testimonials,
  contact,
  footerStyle,
}) => {
  return (
    <footer className={`footer ${footerStyle}`}>
      <a href={logo} className="footer__logo">
        ToyChan
      </a>
      <ul className="permalinks">
        <li>
          <a href={home}>Home</a>
        </li>
        <li>
          <a href={about}>About</a>
        </li>

        <li>
          <a href={experience}>Experience</a>
        </li>
        <li>
          <a href={services}>Services</a>
        </li>
        <li>
          <a href={portfolio}>Portfolio</a>
        </li>
        <li>
          <a href={testimonials}>Testimonials</a>
        </li>
        <li>
          <a href={contact}>Contact</a>
        </li>
      </ul>

      <div className="footer__copyright">
        <small>
          &copy; Ma'in Ghanem. All rights reserved. <br />
          <br />
          <br /> Made with
          {"           "}
          <span style={{ color: "#20A40F", fontSize: "1rem" }}>
            &#10084;
          </span>{" "}
          using ReactJS
        </small>
      </div>
    </footer>
  );
};

Footer.defaultProps = {
  logo: "/#",
  home: "/#",
  about: "/#about",
  experience: "/#experience",
  services: "/#services",
  portfolio: "/#portfolio",
  testimonials: "/#testimonials",
  contact: "/#contact",
  footerStyle: "",
};

export default Footer;
